import MyStaffApplications from "./Template";

const MyLeaveApplications = () => <MyStaffApplications type="leave" />;

export default MyLeaveApplications;
